import React from "react";
import { FACE_SHAPE_LABELS } from "../../lib/faceShape";

/**
 * Face-shape badge shown during the contour step once the classifier
 * has locked on. Tapping opens the calibrator so the user can confirm
 * or override the auto-detected shape.
 */
const LiveCoachFaceShapeBadge = ({ faceShape, onClick }) => {
  if (!faceShape) return null;
  const label = FACE_SHAPE_LABELS[faceShape];
  return (
    <button
      type="button"
      onClick={onClick}
      className="absolute top-[calc(max(env(safe-area-inset-top),20px)+52px)] left-5 z-30 bg-[#1a1416]/70 backdrop-blur-md border border-white/15 rounded-full pl-2 pr-4 py-1.5 flex items-center gap-2 hover:border-[#D5A8A4]/60 hover:bg-[#1a1416]/85 transition-all"
      data-testid="live-coach-face-shape-badge"
      aria-label={`Face shape set to ${label}. Tap to calibrate.`}
    >
      <span className="h-6 w-6 rounded-full bg-[#D5A8A4]/30 border border-[#D5A8A4]/60 flex items-center justify-center text-[10px] font-medium text-[#FFE6D7]">
        {label[0]}
      </span>
      <span className="text-white/85 text-[11px] tracking-wide">
        Contour for{" "}
        <span className="text-[#FFE6D7] font-medium">{label.toLowerCase()}</span>{" "}
        shape
      </span>
      <span className="text-white/50 text-[10px] ml-1 hidden sm:inline">
        · tap to calibrate
      </span>
    </button>
  );
};

export default LiveCoachFaceShapeBadge;
